<div class="rd-widget-slide-out" [class.close]="!showSlideOut && showSlideOut !== null" [class.open]="showSlideOut">
  <div class="closeButton" (click)="onCloseClicked()"></div>
  <section class="content-section">
    <ng-content select="[slide-out-template]"></ng-content>
  </section>
</div>
